import React from "react";
import CSSModules from "react-css-modules";
import { isBotxoDomain } from "utils/rebranding";
import styles from "./spinner.cssmodule.scss";

const isPrevDomain = isBotxoDomain();

const Spinner = () => {
  const prevSpinner = (
    <div className={styles.spinner}>
      <div className={styles.bounce1} />
      <div className={styles.bounce2} />
      <div />
    </div>
  );
  const newSpinner = (
    <div className={styles.ndContainer}>
      <img
        className={styles.ndSpinner}
        alt=""
        src="https://certainly-business-pro-assets.s3.eu-west-1.amazonaws.com/media/spinners/nd-spinner-grey.gif"
      />
    </div>
  );
  const spinner = isPrevDomain ? prevSpinner : newSpinner;

  return spinner;
};

export default CSSModules(Spinner, styles);
